import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class GroupQueryCriteriaClass extends BaseCriteriaModel {
  //hdr table
  namespace?: Optional<string> = Optional.empty();
  group_type?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  description?: Optional<string> = Optional.empty();
  guids?: Optional<string> = Optional.empty();  /** @param guids is comma separated E.g: 4BC80017-22CC-4A29-9511-E22C4EB97AD5,4BC80017-22CC-4A29-9511-E22C4EB97AD5*/

  //ext table
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();

  //link subject to grp
  app_grp_guid?: Optional<string> = Optional.empty();
  app_subject_guid?: Optional<string> = Optional.empty();
  title?: Optional<string> = Optional.empty();
  ranks?: Optional<string> = Optional.empty();
}

export class GroupCriteriaModelQuery {
  query = '';

  constructor(GroupCriteriaModel: GroupQueryCriteriaClass) {

    if (!GroupCriteriaModel) {
      return;
    }

    this.query += GroupCriteriaModel.namespace.filter(x => x !== '').map(x => '&namespace=' + x).orElse('');
    this.query += GroupCriteriaModel.group_type.filter(x => x !== '').map(x => '&group_type=' + x).orElse('');
    this.query += GroupCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += GroupCriteriaModel.description.filter(x => x !== '').map(x => '&description=' + x).orElse('');
    this.query += GroupCriteriaModel.guids.filter(x => x !== '').map(x => '&guids=' + x).orElse('');

    this.query += GroupCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += GroupCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += GroupCriteriaModel.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += GroupCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');

    this.query += GroupCriteriaModel.app_grp_guid.filter(x => x !== '').map(x => '&app_grp_guid=' + x).orElse('');
    this.query += GroupCriteriaModel.app_subject_guid.filter(x => x !== '').map(x => '&app_subject_guid=' + x).orElse('');
    this.query += GroupCriteriaModel.title.filter(x => x !== '').map(x => '&title=' + x).orElse('');
    this.query += GroupCriteriaModel.ranks.filter(x => x !== '').map(x => '&ranks=' + x).orElse('');

    this.query += '&status=' + GroupCriteriaModel.status;
    this.query += '&orderBy=' + GroupCriteriaModel.orderBy;
    this.query += '&order=' + GroupCriteriaModel.order;
    this.query += '&offset=' + GroupCriteriaModel.offset + '&limit=' + GroupCriteriaModel.limit;
  }
}
